export default __webpack_public_path__ + "static/animal_mask-9c5f1238def1d39e5f71f3a765695231.jpg";